import { Employment } from 'src/@core/interfaces/employment/employment.model';
import { ChangeDetectorRef, Component, ElementRef, Inject, Input, NgZone, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MapsAPILoader, MouseEvent } from '@agm/core';
import { NotificationService } from 'src/@core/services/notification.service';
import { JobApplication } from 'src/@core/interfaces/job/job-application.model';
import { ViewUploadedImageComponent } from '../../view-proof-of-work/view-uploaded-image/view-uploaded-image.component';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material';
import { EnterpriseAdminService } from 'src/app/modules/enterprise-admin/enterprise-admin.service';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/components/confirm-delete-dialog/confirm-delete-dialog.component';
import { DeleteEvent } from 'src/@core/interfaces/delete-event';
import { AddEditTaskComponent } from '../../view-proof-of-work/add-edit-task/add-edit-task.component';


@Component({
  selector: 'hour4u-admin-employment-map-view',
  templateUrl: './employment-map-view.component.html',
  styleUrls: ['./employment-map-view.component.scss']
})
export class EmploymentMapViewComponent implements OnInit {

  @Input('employment') employment: Employment;
  @Input('jobApplications') jobApplications: JobApplication[];
  @Input('jobseeker') jobseeker: any;
  @Input('tableWorkImages') tableWorkImages: any;
  @Input('forAll') forAll: any;
  @Input('mapHeight') mapHeight?: any;
  @Input() showAllMarkers: boolean;

  zoom: number = 15;
  isSnazzyInfoWindowOpened = false;
  geoFencingRadius: number = 500;

  markers: any[] = [];
  polylines: any[] = [];
  circle: { lat: number, lng: number };
  baseImageUrl = environment.image_url;
  viewTaskDetails: boolean = false;
  selectedJob: JobApplication
  selectedJobPolyline: any;
  numberOfTasks: number = 0;
  private geoCoder;
  addressObj: any;
  taskMarkers: any[] = [];
  selectedJobTasks: any[] = [];
  selectedJobCheckInImage: any[] = [];
  showTaskDetails: boolean = false;
  roles = roles;
  entityTypes = entityTypes;

  constructor(
    private mapsAPILoader: MapsAPILoader,
    private zone: NgZone,
    private notify: NotificationService,
    private dialog: MatDialog,
    public enterpriseAdminService: EnterpriseAdminService,
    @Inject(ChangeDetectorRef) private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.geoFencingRadius = this.employment.project.geoFencingRadius;
    this.updateZoom();
    console.log("cehcking status", this.employment.workOrder.status === 'Completed')
    console.log("employment dekho", this.employment);
    console.log("job application dekho", this.jobApplications, this.jobseeker);
    console.log("table work image", this.tableWorkImages)
    // console.log("job seeker DP dekho", this.baseImageUrl + this.jobseeker.tempJobSeeker.profilePhoto);
    console.log("forall", this.forAll);

    if (this.forAll == null) {
      this.forAll = true;
    }
    // Initialize selectedJob to null
    this.selectedJobPolyline = null;

    if (this.jobApplications.length) {
      this.jobApplications.forEach(js => {
        if (this.forAll) {
          this.setMarkers(js);
        } else {
          if (js.jobSeekerId == this.jobseeker.id) {
            this.setMarkers(js);
            if (this.jobseeker) {
              this.showTaskDetails = false;
              this.viewTask(js);
            }
          }
        }
      })
    }

    this.showPathsForAllJobSeekers()

  }

  async setMarkers(js) {
    this.zone.run(() => {
      setTimeout(() => {
        if (js.history) {
          // Check if locationHistories is null or not
          if (js.history.locationHistories && js.history.locationHistories.length > 1) {
            // If locationHistories is not null and has more than one entry
            const profilePhotoUrl = this.baseImageUrl + js.tempJobSeeker.profilePhoto;
            const fallbackPhotoUrl = '/assets/img/avatars/male_avatar.svg';
            this.checkImage(profilePhotoUrl).then(url => {
              this.markers.push({
                title: js.tempJobSeeker.name,
                lat: js.history.locationHistories[js.history.locationHistories.length - 1].latitude,
                lng: js.history.locationHistories[js.history.locationHistories.length - 1].longitude,
                draggable: false,
                icon: {
                  url: url,
                  scaledSize: {
                    width: 32,
                    height: 32
                  }
                },
                profilePhoto: url,
                selectedJob: js
              });
            });
          } else if (js.history.imageProofs && js.history.imageProofs.length > 0) {
            // If locationHistories is null, but imageProofs is available and has at least one entry
            const profilePhotoUrl = this.baseImageUrl + js.tempJobSeeker.profilePhoto;
            const fallbackPhotoUrl = '/assets/img/avatars/male_avatar.svg';
            this.checkImage(profilePhotoUrl).then(url => {
              this.markers.push({
                title: js.tempJobSeeker.name,
                lat: js.history.imageProofs[0].latitude,
                lng: js.history.imageProofs[0].longitude,
                draggable: false,
                icon: {
                  url: url,
                  scaledSize: {
                    width: 32,
                    height: 32
                  }
                },
                profilePhoto: url,
                selectedJob: js
              });
            });
          }
        }
      }, 100);
    })
  }


  checkImage(url: string): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(url);
      img.onerror = () => resolve('/assets/img/avatars/male_avatar.svg');
    });
  }


  viewTask(selectedJob: JobApplication) {
    this.polylines = [];
    console.log('viewTask called with:', selectedJob, this.tableWorkImages);
    this.selectedJob = selectedJob;
    if (this.selectedJob.history.locationHistories) {
      this.updateMarkersAndPolyline();
    }

    this.setTaskMarkers(selectedJob.history.imageProofs);

    this.selectedJobTasks = selectedJob.history.imageProofs.filter(proof =>
      proof.proofEnum !== 'START' && proof.proofEnum !== 'END'
    ).reverse();

    this.selectedJobCheckInImage = selectedJob.history.imageProofs.filter(proof =>
      proof.proofEnum === 'START'
    )

    this.selectedJobCheckInImage = this.selectedJobCheckInImage[0];

    console.log(this.selectedJobCheckInImage)

    this.showTaskDetails = true;
    this.changeDetectorRef.detectChanges();
  }


  updateMarkersAndPolyline() {
    console.log('updateMarkersAndPolyline called');
    this.selectedJobPolyline = null;
    const checkoutTime = this.getCheckOutTime(this.selectedJob.history.imageProofs);

    // Clear existing markers
    this.markers = [];

    if (this.selectedJob && this.selectedJob.history && this.selectedJob.history.locationHistories && this.selectedJob.history.locationHistories.length > 0) {
      // Add start marker
      this.markers.push({
        title: this.selectedJob.tempJobSeeker.name,
        lat: this.selectedJob.history.locationHistories[0].latitude,
        lng: this.selectedJob.history.locationHistories[0].longitude,
        draggable: false,
        icon: {
          url: 'assets/check-in.svg'
        },
        profilePhoto: this.baseImageUrl + this.selectedJob.tempJobSeeker.profilePhoto
      });

      // Add polyline for the selected job
      this.selectedJobPolyline = {
        path: this.selectedJob.history.locationHistories.map(history => ({ lat: history.latitude, lng: history.longitude })),
        strokeColor: 'black'
      };
      console.log('selectedJobPolyline:', this.selectedJobPolyline);

      // Add profile picture markers for job applicant
      this.jobApplications.forEach(js => {
        if ((!this.selectedJob || js.jobSeekerId === this.selectedJob.jobSeekerId) && !this.getCheckOutTime(js.history.imageProofs) && js.history.locationHistories) {
          const profilePhotoUrl = this.baseImageUrl + js.tempJobSeeker.profilePhoto;

          this.checkImage(profilePhotoUrl).then(url => {
            this.markers.push({
              title: js.tempJobSeeker.name,
              lat: js.history.locationHistories[js.history.locationHistories.length - 1].latitude,
              lng: js.history.locationHistories[js.history.locationHistories.length - 1].longitude,
              draggable: false,
              icon: {
                url: url,
                scaledSize: {
                  width: 32,
                  height: 32
                }
              },
              profilePhoto: url,
              selectedJob: js
            });
          });
        }
      });
    }

    // Add end marker if checkout time is available
    if (checkoutTime) {
      this.markers.push({
        title: this.selectedJob.tempJobSeeker.name,
        lat: this.selectedJob.history.locationHistories[this.selectedJob.history.locationHistories.length - 1].latitude,
        lng: this.selectedJob.history.locationHistories[this.selectedJob.history.locationHistories.length - 1].longitude,
        draggable: false,
        icon: {
          url: 'assets/check-out.svg' // Use the check-out.svg marker
        },
        profilePhoto: this.baseImageUrl + this.selectedJob.tempJobSeeker.profilePhoto
      });
    }
  }

  setTaskMarkers(imageProofs: any[]) {
    // Clear existing task markers
    this.taskMarkers = [];

    // Loop through image proofs to set task markers
    imageProofs.forEach((proof) => {
      if (proof.latitude !== null && proof.longitude !== null && proof.proofEnum !== 'START' && proof.proofEnum !== 'END') {
        this.taskMarkers.push({
          title: 'Task Marker',
          lat: proof.latitude,
          lng: proof.longitude,
          draggable: false,
          icon: {
            url: 'assets/task-on-map.svg',
            scaledSize: {
              width: 32,
              height: 32
            }
          }
        });
      }
    });
  }

  onMouseOver(infoWindow, gm) {
    if (gm.lastOpen != null) {
      gm.lastOpen.close();
    }
    gm.lastOpen = infoWindow;
    infoWindow.open();
  }

  getCircleLatitude() {
    return this.employment.workOrder.venue.location.latitude;
  }

  getCircleLongitude() {
    return this.employment.workOrder.venue.location.longitude;
  }

  getTaskCount(imageProofs: any[]): number {
    if (!imageProofs) return 0;
    return imageProofs.filter(imageProof => imageProof.proofEnum === 'MIDDLE').length;
  }

  getCheckInTime(imageProofs: any[]): string {
    if (!imageProofs) return '';
    const startProof = imageProofs.find(proof => proof.proofEnum === 'START');
    return startProof ? startProof.dateTime : '';
  }

  getCheckOutTime(imageProofs: any[]): string {
    if (!imageProofs) return '';
    const endProof = imageProofs.find(proof => proof.proofEnum === 'END');
    return endProof ? endProof.dateTime : '';
  }

  updateZoom() {
    if (this.geoFencingRadius >= 10000) {
      this.zoom = 10;
    } else if (this.geoFencingRadius >= 5000) {
      this.zoom = 13;
    } else if (this.geoFencingRadius >= 2500) {
      this.zoom = 14;
    } else if (this.geoFencingRadius >= 1000) {
      this.zoom = 15;
    } else if (this.geoFencingRadius >= 500) {
      this.zoom = 16;
    } else if (this.geoFencingRadius >= 200) {
      this.zoom = 17;
    } else if (this.geoFencingRadius >= 100) {
      this.zoom = 18;
    }
  }

  viewUploadedImage(element: any) {
    console.log("element", element)
    if (element.fieldValue || element.imagePath) {
      //const imagePath = this.baseImageUrl + element.imagePath;
      const dialogRef = this.dialog.open(ViewUploadedImageComponent, {
        width: '1024px',
        panelClass: 'add-edit-user-dialog',
        disableClose: true,
        data: {
          imageUrl: element.fieldValue || this.baseImageUrl + element.imagePath,
          selectedTask: element,
          title: 'View Task Image'
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
        }
      });
    } else {
      console.error('Image URL not available.');
    }
  }

  // approve Reject Task
  // approveRejectTask(data, status) {
  //   console.log("datadata", data, status)
  //   let param = {
  //     id: data.id,
  //     employmentHistoryId: data.employmentHistoryId,
  //     imageProfPath: data.imagePath,
  //     updatedStatus: status,
  //   }
  //   this.enterpriseAdminService.updateTaskStatus(param).subscribe(async (res) => {
  //     this.notify.showMessage("Work Order status updated Successfully!", 2000);
  //     this.viewTask(this.selectedJob);
  //   }, (err => {
  //     this.notify.showMessage("Work Order status update failed!", 2000);
  //   }))
  // }

  approveRejectTask(data, status) {
    console.log("datadata", data, status)
    let param = {
      id: data.id,
      employmentHistoryId: data.employmentHistoryId,
      imageProfPath: data.imagePath,
      updatedStatus: status,
    }
    this.enterpriseAdminService.updateTaskStatus(param).subscribe(async (res) => {
      console.log("API Response:", res); // Log API response
      this.notify.showMessage("Task " + status.toLowerCase() + " successfully!", 2000);

      // Log the IDs of tasks in the tableWorkImages array
      console.log("Task IDs in tableWorkImages:", this.tableWorkImages.map(task => task.id));

      // Update the status of the task in the tableWorkImages array
      const updatedTaskIndex = this.tableWorkImages.findIndex(task => task.id === data.id);
      if (updatedTaskIndex !== -1) {
        this.tableWorkImages[updatedTaskIndex].status = status;
        this.changeDetectorRef.detectChanges(); // Trigger change detection
      } else {
        console.error('Task not found in tableWorkImages array');
      }
    }, (err => {
      this.notify.showMessage("Work Order status update failed!", 2000);
    }));
  }



  addEditTasks(selectedData?: any) {
    console.log(selectedData);
    if (selectedData) {
      if (!this.selectedJob) {
        for (let i = 0; i < this.jobApplications.length; i++) {
          let jobApp = this.jobApplications[i];
          if (jobApp.id === selectedData.id) {
            this.selectedJob = jobApp;
            break;
          }
        }
      }
    }

    if (!selectedData) {
      let workProofs = [];
      if (this.jobApplications && this.jobApplications.length) {
        this.jobApplications[0].proofOfWork.proofOfWorkFields.forEach(element => {
          let obj = {
            fieldLabel: element.requiredInfoFieldLabel,
            fieldName: element.requiredInfoFieldName,
            fieldValue: "",
            fieldType: element.requiredInfoFieldType
          };
          workProofs.push(obj);
        });
      }
      selectedData = {
        label: 'Add',
        imagePath: "",
        workProofs: workProofs
      };
    } else {
      selectedData.label = 'Edit';
    }

    selectedData.employmentId = this.employment.workOrder.id;
    selectedData.champsList = this.jobApplications;
    selectedData.forAll = this.forAll;

    const dialogRef = this.dialog.open(AddEditTaskComponent, {
      width: '500px',
      data: {
        selectedTask: selectedData,
        selectedJob: this.selectedJob
      },
      panelClass: 'add-edit-venue-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //this.loadJobApplications();
      }
    });
  }


  // delete Task
  deleteTask(row) {
    const data = new DeleteEvent();
    data.setId(row.id);
    data.setName(row.tempJobSeekerName);
    data.setType('Proof Of Work');
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      disableClose: true,
      data
    });

    dialogRef.afterClosed().subscribe(code => {
      if (code) {
        this.deleteImage(row);
      }
    });
  }



  // delete attendance Image
  // async deleteImage(data: any) {
  //   let param = {
  //     id: data.id,
  //     previousImagePath: data.imagePath,
  //     workOrderId: this.employment.workOrder.id,
  //     jobSeekerId: data.jobSeekerId,
  //     proofEnum: data.proofEnum,
  //     description: data.description
  //   }
  //   this.enterpriseAdminService.DeleteAttendanceImgProof(param).subscribe(async (res) => {
  //     this.notify.showMessage("Work Picture deleted Successfully!", 2000);
  //     //this.loadJobApplications();
  //   }, (err => {
  //     this.notify.showMessage("Work Picture deleted failed!", 2000);
  //   }))
  // }

  async deleteImage(data: any) {
    let param = {
      id: data.id,
      previousImagePath: data.imagePath,
      workOrderId: this.employment.workOrder.id,
      jobSeekerId: data.jobSeekerId,
      proofEnum: data.proofEnum,
      description: data.description
    };
    this.enterpriseAdminService.DeleteAttendanceImgProof(param).subscribe(async (res) => {
      this.notify.showMessage("Work Picture deleted Successfully!", 2000);

      // Remove the deleted task from the tableWorkImages array
      const deletedTaskIndex = this.tableWorkImages.findIndex(task => task.id === data.id);
      if (deletedTaskIndex !== -1) {
        this.tableWorkImages.splice(deletedTaskIndex, 1);
        this.changeDetectorRef.detectChanges(); // Trigger change detection
      } else {
        console.error('Task not found in tableWorkImages array');
      }
    }, (err => {
      this.notify.showMessage("Work Picture deleted failed!", 2000);
    }));
  }

  getField(task: any, fieldLabels: string[]): string | null {
    if (task && task.workProofs) {
      const proof = task.workProofs.find((proof: any) =>
        fieldLabels.includes(proof.fieldLabel) && proof.fieldType == 'text'
      );
      return proof ? proof.fieldValue : null;
    }
    return null;
  }


  onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = '/assets/img/avatars/male_avatar.svg';
  }

  // Method to show markers for all tasks of the jobseeker at once
  public showAllTaskMarkers() {
    this.taskMarkers = [];
    this.markers = [];

    this.jobApplications.forEach(js => {
      if (js.history && js.history.imageProofs) {
        const uniqueLocations = new Set<string>();

        js.history.imageProofs.forEach(location => {
          // Filter out entries with proofEnum 'START' or 'END'
          if (location.proofEnum !== 'START' && location.proofEnum !== 'END') {
            const locationKey = `${location.latitude},${location.longitude}`;

            // Check if this location is already added to the set
            if (!uniqueLocations.has(locationKey)) {
              uniqueLocations.add(locationKey);

              // Push the marker only if the location is unique and not START/END
              this.taskMarkers.push({
                title: `Task for ${js.tempJobSeeker.name}`,
                lat: location.latitude,
                lng: location.longitude,
                draggable: false,
                icon: {
                  url: 'assets/task-on-map.svg',
                  scaledSize: {
                    width: 32,
                    height: 32
                  }
                }
              });
            }
          }
        });
      }
    });
  }

  showPathsForAllJobSeekers() {
    if (this.jobApplications.length) {
      this.jobApplications.forEach(js => {
        if (js.history && js.history.locationHistories && js.history.locationHistories.length > 1) {
          const polylinePath = js.history.locationHistories.map(history => ({
            lat: history.latitude,
            lng: history.longitude
          }));

          this.polylines.push({
            path: polylinePath,
            strokeColor: 'blue', // Customize polyline color
            strokeOpacity: 0.7,
            strokeWeight: 2
          });

          const profilePhotoUrl = this.baseImageUrl + js.tempJobSeeker.profilePhoto;
          this.checkImage(profilePhotoUrl).then(url => {
            this.markers.push({
              title: js.tempJobSeeker.name,
              lat: js.history.locationHistories[js.history.locationHistories.length - 1].latitude,
              lng: js.history.locationHistories[js.history.locationHistories.length - 1].longitude,
              draggable: false,
              icon: {
                url: url,
                scaledSize: {
                  width: 32,
                  height: 32
                }
              },
              profilePhoto: url,
              selectedJob: js
            });
          });
        }
      });
    }
  }


}
